import React from "react";
import { TOOL_COATINGS } from "../data/machiningMaterials";

const ToolCoatingSelector = ({ value, onChange, error }) => (
  <div className="form-group">
    <label>Tool Coating</label>
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className={error ? "error" : ""}
    >
      {Object.entries(TOOL_COATINGS).map(([key, coating]) => (
        <option key={key} value={key}>
          {coating.label}
        </option>
      ))}
    </select>
    {error && <span className="error-text">{error}</span>}
  </div>
);

export default ToolCoatingSelector;
